import cn from 'classnames'
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from '@emotion/react'

import customPropTypes from 'util/customPropTypes'
import { Accordion, Icon } from 'util/ui'
import SidebarLabel from 'components/App/DesktopView/Layout/Sidebar/SidebarLabel'
import { paddedSpacing } from './paddedLevelStyle'

import styles from './styles.less'

class SidebarAccordion extends React.PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    children: customPropTypes.children.isRequired,
    initiallyActive: PropTypes.bool,
    title: PropTypes.string.isRequired,
    padded: PropTypes.number,
    size: PropTypes.oneOf(['large', 'small']),
  }

  static defaultProps = {
    active: null,
    initiallyActive: false,
    padded: 1,
    size: 'small',
  }

  constructor(props) {
    super(props)
    this.state = {
      active: props.initiallyActive,
    }
  }

  toggleActive = event => {
    const { onToggle } = this.props
    const newActive = !this.state.active
    this.setState({ active: !this.state.active })
    if (onToggle) onToggle(event, newActive)
  }

  get isActive() {
    if (this.props.active === true || this.props.active === false)
      return this.props.active
    return this.state.active
  }

  render() {
    const {
      children,
      title,
      padded,
      size,
      theme: {
        color: { monochrome },
      },
    } = this.props

    return (
      <Accordion inverted>
        <Accordion.Title
          active={this.isActive}
          onClick={this.toggleActive}
          css={paddedSpacing({ padded, size })}
          className={cn(
            styles.SidebarItem,
            styles.SidebarAccordion_TitleContainer,
            styles.clickable
          )}
        >
          <SidebarLabel
            size="small"
            color={monochrome.white}
            className={styles.SidebarAccordion_Title}
          >
            {title}
          </SidebarLabel>
          <Icon
            name="dropdown"
            className={styles.SidebarAccordion_DropdownIcon}
          />
        </Accordion.Title>
        <Accordion.Content
          active={this.isActive}
          className={styles.SidebarAccordion_Content}
        >
          {children}
        </Accordion.Content>
      </Accordion>
    )
  }
}

export default withTheme(SidebarAccordion)
